export interface ImageProps {
  src: string;
  alt: string;
  srcset?: string[];
  sizes?: string[];
  lazyloaded?: boolean;
}

export const CLASS_FOR_LAZYLOADING = 'lazyloaded';
